module.exports = __webpack_public_path__ + "img/big7-1.9381ec17.jpg";